var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.copied)?_c('span',[_c('v-icon',{staticClass:"ml-3",attrs:{"color":"secondary"},on:{"click":function($event){_vm.copyToClipboard()}}},[_vm._v("fa-copy")])],1):_c('span',[_c('small',[_vm._v("copied")])])])}
var staticRenderFns = []

export { render, staticRenderFns }